import axios from 'axios';
import { NewsletterData } from '../models/NewsletterData';
import { REACT_APP_BACKEND_API_URL } from '../../../shared/utils/config';

export const addToNewsletter = async (data: NewsletterData): Promise<any[]> => {
  const headers = {
    'Content-Type': 'application/json',
  };
  const baseURL = REACT_APP_BACKEND_API_URL;

  return axios
    .create({ baseURL, headers })
    .put<any[]>('/early-access/add', data)
    .then((response: any) => response?.data);
};
